<div class="mat-typography root-container">
  <router-outlet></router-outlet>
</div>
